/**
 * Listing link / unlink / URL modals — same shell as user-dash input dialogs
 * (Change password, Account, Branding): full-screen on mobile, shapeShell
 * radius on desktop, maxWidth sm, glass input fields, pill CTAs.
 */
import { shapeShell } from '../../theme/shape';

export const LISTING_INPUT_MODAL_TITLE_SX = {
  fontWeight: 600,
  letterSpacing: '-0.02em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: { xs: 2.5, sm: 3 },
};

export const LISTING_INPUT_MODAL_CONTENT_SX = {
  px: { xs: 2, sm: 3 },
  pb: {
    xs: 'max(env(safe-area-inset-bottom, 0px) + 24px, 24px)',
    sm: 3,
  },
  pt: { xs: 2, sm: 2.25 },
};

/** Dialog props shared by listing-management modals with form fields. */
export const getListingInputModalDialogProps = (fullScreenDialog) => ({
  fullScreen: fullScreenDialog,
  fullWidth: true,
  maxWidth: 'sm',
  scroll: 'paper',
  sx: {
    '& .MuiDialog-paper': {
      ...(fullScreenDialog && { maxHeight: '100dvh' }),
      ...(!fullScreenDialog && { borderRadius: shapeShell }),
    },
    '& .MuiDialogContent-root': {
      WebkitOverflowScrolling: 'touch',
    },
  },
});
